import { Image, merge, Stack, Text } from '@fluentui/react';
import React, { useMemo } from 'react';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';

const Pictogramme = (props) => {

    const {
        label = "Label",
        src = ""
    } = props;

    const { responsiveSize } = useResponsiveSize();

    const styles = useMemo(
        () => {
            let styles = {
                image: {
                    image: {
                        minHeight: 32,
                        paddingBottom: 8,
                        width: 32,
                    }
                },
                label: {
                    root: {
                        color: "black",
                        fontSize: 12,
                        lineHeight: "12px",
                        textAlign: "center",
                    }
                },
                outer: {
                    root: {
                        background: "white",
                        borderRadius: 8,
                        height: 81,
                        opacity: 1,
                        padding: "8px 12px",
                        width: 87,
                    }
                }
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        image: {
                            image: {
                                minHeight: 50,
                                paddingBottom: 10,
                                width: 50,
                            }
                        },
                        label: {
                            root: {
                                fontSize: 16,
                                lineHeight: "15px",
                            }
                        },
                        outer: {
                            root: {
                                height: 125,
                                padding: "14px 26px",
                                width: 135,
                            }
                        }
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    return <Stack horizontalAlign="center" styles={styles.outer} verticalAlign="center">
        <Image src={src} styles={styles.image} />
        <Text styles={styles.label}>{label}</Text>
    </Stack>;

};

export default Pictogramme;